<template>
    <div class="animated fadeIn targetsales">     
        <b-card>
            <div slot="header">Target Sales
                <div class="card-header-actions">
                    <b-button variant="primary mr-1" @click="edit">Add/Edit</b-button>
                    <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> print</b-button>
                    <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
                    <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
                </div>
            </div>
            <b-row >
                <b-col lg="2">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Year Of</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tahun" type="number" @change="gantiTahun" :state="!$v.filter.tahun.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="1">
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Open</b-button>
                </b-col>

            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table >
                        <thead>
                            <tr>
                            <th width="400px">Sales Name</th>
                            <th style="text-align:right" width="110px">{{periode[0]}}</th>
                            <th style="text-align:right" width="110px">{{periode[1]}}</th>
                            <th style="text-align:right" width="110px">{{periode[2]}}</th>
                            <th style="text-align:right" width="110px">{{periode[3]}}</th>
                            <th style="text-align:right" width="110px">{{periode[4]}}</th>
                            <th style="text-align:right" width="110px">{{periode[5]}}</th>
                            <th style="text-align:right" width="110px">{{periode[6]}}</th>
                            <th style="text-align:right" width="110px">{{periode[7]}}</th>
                            <th style="text-align:right" width="110px">{{periode[8]}}</th>
                            <th style="text-align:right" width="110px">{{periode[9]}}</th>
                            <th style="text-align:right" width="110px">{{periode[10]}}</th>
                            <th style="text-align:right" width="110px">{{periode[11]}}</th>
                            <th style="text-align:right" width="110px">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.salesae_id">
                            <td :class="row.kelas">{{row.salesae_name}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget1 | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget2 | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget3 | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget4 | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget5 | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget6 | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget7 | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget8 | numFormat}}</td>
                            <td :class="row.kelas" style="text-align:right">{{row.budget9 | numFormat}}</td>
                            <td :class="row.kelas"  style="text-align:right">{{row.budget10 | numFormat}}</td>
                            <td :class="row.kelas"  style="text-align:right">{{row.budget11 | numFormat}}</td>
                            <td :class="row.kelas"  style="text-align:right">{{row.budget12 | numFormat}}</td>
                            <td :class="row.kelas"  style="text-align:right">{{row.budget | numFormat}}</td>
                            </tr>
                            <tr>
                                <td style="text-align:right" >TOTAL : &nbsp;</td>
                                <td style="text-align:right" class="total">{{periodeTotal[0] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[1] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[2] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[3] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[4] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[5] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[6] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[7] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[8] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[9] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[10] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[11] | numFormat}}</td>
                                <td style="text-align:right" class="total">{{periodeTotal[12] | numFormat}}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .targetsales {
        .report-wraper {
            width:100%;
            overflow-x: auto;
            overflow-y: auto;

            table {
                font-size: smaller;
                th {
                    border-bottom: 1px solid #D1D1D1;
                    padding: 0 15px;
                    height: 30px;
                    background: #e8e8e8;
                }              
                td {
                    border-bottom: 1px solid #e0e0e0;
                    padding: 0 10px;
                    height: 40px;
                }
                
                td.tebal {
                    font-weight: bold;
                }
                
                td.subtotal {
                    border-top: 2px solid #000 !important;
                }
                
                td.total {
                    border-top: 2px solid #000 !important;
                    background: #e6e6e6 !important;
                }
                
                td.grdtotal {
                    border-top: 2px solid #000!important;
                    border-bottom: 2px solid #000 !important;
                    background: #e6e6e6 !important;
                }
                tbody tr:hover {
                    background-color: rgba(0, 0, 0, 0.05) !important;
                    cursor: default;
                }            
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import targetsales from "../../apis/targetsales";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tahun: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'', departkd:'',tahun:moment(this.$store.state.user.tglaktif).format('YYYY')},
      nextYear: parseInt(this.$store.state.user.tglaktif.substring(0,4))+1,
        awalbln:this.$store.state.user.awalbln || 1,
        periode:['Jan ','Feb ','Mar ','Apr ','May ','Jun ','Jul ','Aug ','Sep ','Oct ','Nov ','Dec '],
        periodeTotal:[0,0,0,0,0,0,0,0,0,0,0,0,0],
      enableNextYear: true,
      lkuDeptShow:false,
      isLoading: false,
      showAddConfirm:false,
      layouts:[],
      horizontal: true,
      reportUrl: `${location.origin}/#load`,
      showReport:false,
      rptLines:[{salesae_id:''}]
    };
  },
components: {Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },
// watch:{
//       layout: async function(newval) {
//           this.rptLines= await targetsales.layout({layout : newval});
//       }
//   },
created: async function (){
        let thn=parseInt(this.filter.tahun);
        let bln=parseInt(this.awalbln)-1;
        const blnaktif = this.$store.state.user.tglaktif;
        for (let index = 0; index < 12; index++) {
            bln += 1;
            if (bln>12) {
                thn += 1;
                bln = 1;
            }
            this.periode[index]=moment(`${thn}-${bln}-01`,'YYYY-MM-DD').format('MMM YYYY');
        }
  },
methods:{
    gantiTahun:  function (){
        this.rptLines=[]
        let thn=parseInt(this.filter.tahun);
        let bln=parseInt(this.awalbln)-1;
        for (let index = 0; index < 12; index++) {
            bln += 1;
            if (bln>12) {
                thn += 1;
                bln = 1;
            }
            this.periode[index]=moment(`${thn}-${bln}-01`,'YYYY-MM-DD').format('MMM YYYY');
        }
  },
    onSelectLkuDept: async function (_selected) {
        this.filter.departemen = _selected.departkd.trim() + ' | ' + _selected.departemen.trim();
        this.filter.departid = _selected.departid;
        this.filter.departkd = _selected.departkd;
        this.lkuDeptShow=false;
    },
    add() {
        // this.model= {copysrc:0,markup:0,tahunsrc: this.nextYear-1};
        // console.log('model : ', this.model);
          this.showAddConfirm = true;
    },
    edit: function() {
        if (this.$v.filter.tahun.$error) {
            toastr.warn('Please select YEAR');
        } else {
          router.push({name :'sales.targetsalesfrm', params: { tahun: this.filter.tahun}});
        }
    },    
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                this.rptLines=[];
                this.rptLines= await targetsales.view(this.filter);
                this.rptLines.forEach(element => {
                    this.periodeTotal[0] += (element.budget1 || 0);
                    this.periodeTotal[1] += (element.budget2 || 0);
                    this.periodeTotal[2] += (element.budget3 || 0);
                    this.periodeTotal[3] += (element.budget4 || 0);
                    this.periodeTotal[4] += (element.budget5 || 0);
                    this.periodeTotal[5] += (element.budget6 || 0);
                    this.periodeTotal[6] += (element.budget7 || 0);
                    this.periodeTotal[7] += (element.budget8 || 0);
                    this.periodeTotal[8] += (element.budget9 || 0);
                    this.periodeTotal[9] += (element.budget10 || 0);
                    this.periodeTotal[10] += (element.budget11 || 0);
                    this.periodeTotal[11] += (element.budget12 || 0);
                    this.periodeTotal[12] += (element.budget || 0);
                });
                // console.log(periodeTotal);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                this.reportUrl= await targetsales.viewprint(this.filter);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await targetsales.viewexport(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },

    close(){
      router.push({name: "sales.home"});
    }
  }
};
</script>
